"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundCloudService = void 0;
var axios = require('axios');
var SoundCloudService = /** @class */ (function () {
    function SoundCloudService(config) {
        this.config = config;
    }
    SoundCloudService.prototype.search = function (params) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var type = '/search/tracks';
            var cors = "https://cors-proxy-server.onrender.com/";
            params.client_id = params.client_id ? params.client_id : _this.config.clientId;
            var urlParameters = Object.entries(params)
                .map(function (e) { return e.join("="); })
                .join("&");
            var url = "".concat(cors, "https://api-v2.soundcloud.com").concat(type, "?").concat(urlParameters);
            axios({
                url: url
            })
                .then(function (res) { return resolve(res.data); })
                .catch(function (err) { return reject(err); });
        });
    };
    return SoundCloudService;
}());
exports.SoundCloudService = SoundCloudService;
